import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table, Button, Tooltip, Drawer,
} from 'antd';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import ProductActions from '@Actions/productActions';
import OfferActions from '@Actions/offerActions';
import imageDefault from '@Images/icons/imageDefault.png';
import closeIcon from '@Images/icons/icon-close-blue.png';
import noOffers from '@Images/creative-no-search-results.png';
import CartActions from '@Actions/cartActions';
import './style.scss';
import { LoadingOutlined } from '@ant-design/icons';
import { QUANTITY } from '@Apis/constants';

/**
 *
 */
class ProductsList extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      keyword: '',
      showUpdateProductModal: false,
      selectedSkuProduct: {},
      productListColumns: [
        {
          title: '',
          render: (text, record) => (
              record?.product_info?.assets?.[0]?.url
                ? <H3Image src={`${record?.product_info?.assets[0].url}`} className="prod-table__image" />
                : <H3Image src={imageDefault} className="prod-table__image prod-table__image__default" />
          ),
          width: '60px',
        },
        {
          title: 'Product Name',
          render: (text, record) => (
            <React.Fragment>
              <H3Text text={`${record?.product_info?.product_sku_name}`} className="prod-table__text" />
            </React.Fragment>
          ),
        },
        {
          title: 'Available Qty',
          render: (text, record) => (
            <H3Text text={`${QUANTITY(record?.available_qty, record?.product_info?.uom_info?.precision) || '0'} ${record?.product_info?.uom_info?.uqc?.toProperCase()}`} className={` ${(record?.available_qty >= record?.threshold_qty) ? 'prod-table__text' : 'prod-table__text'}`} />
          ),
        },
        {
          title: 'Stock Status',
          render: (text, record) => (
            <H3Text text={this.getStockStatus(record).label} className={this.getStockStatus(record)?.className} />
          ),
        },
        {
          title: 'Tax',
          render: (text, record) => (
            <H3Text text={`${record?.tax_info?.tax_value}%`} className="prod-table__text" />
          ),
        },
        {
          title: '',
          key: 'action',
          render: (text, record) => {
            const {
              getOffers,
            } = this.props;
            return (
              <div style={{
                textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center',
              }}
              >
                <div
                  className="bu-product__vendors-button"
                  onClick={() => {
                    getOffers(record?.tenant_product_id, '');
                    this.setState({ showProductOffersSlider: true, selectedVendorProduct: record });
                  }}
                >
                  Vendor Prices
                </div>
              </div>
            );
          },
        },
      ],
      mobileProductLength: 10,
    };
  }

  /**
   *
   */
  componentDidMount() {

  }

  /**
   *
   * @param props
   * @param state
   * @return {{isUserReady}|*|(*&{isUserReady: boolean})}
   */
  static getDerivedStateFromProps(props, state) {
    if ((props.selectedTenant && !state.selectedTenant) || (props.selectedTenant && state.selectedTenant && props.selectedTenant?.tenant_id !== state.selectedTenant?.tenant_id)) {
      const { getProducts } = props;
      getProducts('', props?.selectedTenant?.tenant_id, null, 10, 1);
      return {
        ...state,
        isUserReady: true,
        selectedTenant: props.selectedTenant,
      };
    }
    return state;
  }

  /**
   *
   * @param record
   * @return {{className: string, label: string}}
   */
  getStockStatus(record) {
    if (record?.available_qty >= record?.threshold_qty && (record?.threshold_qty !== 0)) {
      return { label: 'Well Stocked', className: 'product_stock-status__stocked' };
    }
    if ((record?.available_qty < record?.threshold_qty)
        && record?.available_qty > 0) {
      return { label: 'Running Low', className: 'product_stock-status__low' };
    }
    return { label: 'Out of Stock', className: 'product_stock-status__ooo' };
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      products, getProductsLoading, getProducts,
      offers, getCartLoading, selectedTenant, getOffersLoading, MONEY,
    } = this.props;
    const {
      productListColumns, keyword, showProductOffersSlider, selectedVendorProduct, mobileProductLength, selectedStatus,
    } = this.state;
    return (
      <Fragment>
        <div className="bu-inventory__wrapper">
          <div className="ant-row">
            <div className={showProductOffersSlider === true ? 'ant-col-md-24' : 'ant-col-md-24 ant-col-xs-24'}>
              <div className="inventory__inner__wrapper">
                <div className="inventory__table__wrapper">
                  <Table
                    title={() => `${(products && products.count) ? products.count : '0'} Products in Inventory`}
                    loading={getProductsLoading || getCartLoading}
                    showHeader
                    size="small"
                    scroll="scroll"
                    columns={productListColumns}
                    dataSource={products && products?.result?.products ? products?.result?.products : []}
                    pagination={products?.count > 10 ? {
                      defaultCurrent: 1,
                      total: products ? products.count : 0,
                      pageSize: 10,
                      position: ['bottomRight'],
                      showSizeChanger: false,
                      onChange: (page) => {
                        this.setState({ showProductOffersSlider: false, currentPage: page });
                        // eslint-disable-next-line max-len
                        getProducts(keyword, selectedTenant?.tenant_id, selectedStatus, 10, page);
                      },
                    } : false}
                    rowClassName={(item) => (selectedVendorProduct?.product_sku_id === item?.product_sku_id ? 'inventory__table__selected-row' : '')}
                  />
                  <div className="product-list__wrapper-mobile">
                    <div className="product-list__mobile-title">
                      {`${(products && products?.products?.length) || '0'} Products In Your Inventory`}
                    </div>
                    <div className="product-list__mobile-body">
                      {!getProductsLoading
                        ? products?.products?.filter((record) => record)?.splice(0, mobileProductLength)?.map(
                          (item) => (
                            <div key={item?.product_sku_id} className="product-list__mobile-card-wrapper">
                              <div className="product-list__mobile-card-picture">
                                {
                                          item?.product_info?.assets?.[0]?.url
                                            ? <H3Image src={`${item?.product_info?.assets?.[0].url}`} className="prod-table__image" />
                                            : <H3Image src={imageDefault} className="prod-table__image prod-table__image__default" />
                                }
                              </div>
                              <div className="product-list__mobile-card-details">
                                <div className="product-list__mobile-card-title">
                                  {item?.product_info?.product_sku_name}
                                </div>
                                <div className="product-list__mobile-card-description">
                                  <div className="product-list__mobile-card-description-right">
                                    <div className="product-list__mobile-card-quantity">
                                      <H3Text text={`${item?.available_qty || '0'} ${item?.product_info?.unit?.toProperCase()}`} className={` ${(item?.available_qty >= item?.threshold_qty) ? 'prod-table__text' : 'prod-table__text'}`} />
                                    </div>
                                    <div className="product-list__mobile-card-name">
                                      <Fragment>
                                        {item?.tenants && item?.default_offer_info?.offer_price && (
                                          <Tooltip title={item?.default_offer_info?.seller_info?.seller_name}>
                                            <span className="prod-table__text prod-table__text-hover">
                                              {item?.default_offer_info ? MONEY(item?.default_offer_info?.offer_price) : 'NA'}
                                            </span>
                                          </Tooltip>
                                        )}
                                        {item?.tenants && item?.offers && item?.offers?.[0]?.offer_info && (
                                          <H3Text
                                            text={item?.default_offer_info?.seller_info?.seller_name}
                                            className="prod-table__subtext"
                                          />
                                        )}
                                      </Fragment>
                                    </div>
                                  </div>
                                  <div className="product-list__mobile-card-description-left">
                                    <div
                                      className="product-list__mobile-card-view-button"
                                      onClick={() => {
                                        this.setState({
                                          showProductOffersSlider: true,
                                          selectedVendorProduct: item,
                                        });
                                      }}
                                    >
                                      View
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ),
                        )
                        : [1, 2, 3, 4].map((item) => (
                          <div className="ant-col-md-5 ant-col-xs-24" key={item}>
                            <div className="loadingBlock mobile__card-loader" />
                          </div>
                        ))}
                      {!getProductsLoading && products && products.count >= mobileProductLength && (
                        <div className="product-list__mobile-card-load-more-wrapper">
                          <Button
                            onClick={() => this.setState({ mobileProductLength: mobileProductLength + 10 })}
                            className="product-list__mobile-card-load-more-button"
                          >
                            Load More
                          </Button>
                        </div>
                      )}

                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Drawer
              placement="right"
              onClose={() => this.setState({ showProductOffersSlider: false, selectedVendorProduct: null })}
              open={showProductOffersSlider}
              width="320px"
              destroyOnClose
            >
              <div className="custom-drawer__header-wrapper">
                <div className="custom-drawer__header" style={{ width: '270px' }}>
                  <H3Text text="Vendor Prices" className="custom-drawer__title" />
                  <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ showProductOffersSlider: false })} />
                </div>
              </div>
              <div className="bu-inventory__slider">
                <div className="bu-inventory__slider__body">
                  {offers?.offers ? offers?.offers
                    ?.map((item) => (
                      <div key={item?.sku_offer_id} className="bu-inventory__slider__vendor">
                        <div className="" style={{ width: '100%' }}>
                          <H3Text text={item.seller_info.seller_name} className="bu-inventory-slider__vendor-name" />
                          <H3Text text={MONEY(item?.offer_price)} className="inventory-slider__vendor-price" />
                        </div>
                      </div>
                    )) : (
                    <Fragment>
                        {!getOffersLoading ? (
                        <div className="no-vendor-prices__wrapper">
                            <H3Image src={noOffers} className="no-vendor-prices__image" />
                            <H3Text text="No vendor prices for this product" className="no-vendor-prices__text" />
                          </div>
                      ) : (
                        <div className="no-vendor-prices__loader">
                          <LoadingOutlined />
                        </div>
                      )}
                      </Fragment>
                  )}
                </div>
              </div>
            </Drawer>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers, ProductReducers, SellerReducers, OfferReducers, CartReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  products: ProductReducers.products,
  getProductsLoading: ProductReducers.getProductsLoading,
  getSellersLoading: SellerReducers.getSellersLoading,
  sellers: SellerReducers.sellers,
  updateSellerOffersLoading: SellerReducers.updateSellerOffersLoading,
  addProductVendorLoading: ProductReducers.addProductVendorLoading,
  productOffers: ProductReducers.productOffers,
  getOffersLoading: OfferReducers.getOffersLoading,
  offers: OfferReducers.offers,
  cart: CartReducers.cart,
  getCartLoading: CartReducers.getCartLoading,

});

const mapDispatchToProps = (dispatch) => ({
  getProducts: (keyword, tenantId, stockStatus, limit, page) => dispatch(ProductActions.getProducts(keyword, tenantId, stockStatus, limit, page)),
  setDefaultOffer: (payload, callback) => dispatch(ProductActions.setDefaultOffer(payload, callback)),
  getOffers: (tenantProductId, tenantSellerId) => dispatch(OfferActions.getOffers(tenantProductId, tenantSellerId)),
  getCart: (tenantId) => dispatch(CartActions.getCart(tenantId)),
  addToCart: (payload, tenantId, callback) => dispatch(CartActions.addToCart(payload, tenantId, callback)),

});

ProductsList.propTypes = {
  getProducts: PropTypes.func,
  getProductsLoading: PropTypes.bool,
  products: PropTypes.any,
  getOffers: PropTypes.func,
  offers: PropTypes.any,
  getCartLoading: PropTypes.bool,
  MONEY: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ProductsList));
